"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_1 = require("react-science/ui");
const useSpectrum_1 = __importDefault(require("../hooks/useSpectrum"));
const emptyData = { info: {}, meta: {} };
function InformationPanel() {
    const { info, meta, customInfo } = (0, useSpectrum_1.default)(emptyData);
    const data = (0, react_1.useMemo)(() => [
        { description: 'Custom information', data: customInfo || {} },
        { description: 'Spectrum information', data: info || {} },
        { description: 'Other spectrum parameters', data: meta || {} },
    ], [customInfo, info, meta]);
    return (0, jsx_runtime_1.jsx)(ui_1.InfoPanel, { data: data, title: "" });
}
exports.default = InformationPanel;
